import React, { forwardRef } from 'react'
import cx from 'classnames'

const FlexChild = forwardRef(({
  className,
  minWidth,
  maxWidth,
  grow,
  ...props
}: {
  grow?: number
  className?: string
  minWidth?: number|null
  maxWidth?: number|null
}, ref: any) => {
  const classes = cx(className)
  const growValue = grow || 1

  return (
    <div
      style={{
        flex: `${growValue} 1 auto`,
        minWidth: minWidth && minWidth >= 0 ? minWidth : undefined,
        maxWidth: maxWidth && maxWidth >= 0 ? maxWidth : undefined,
      }}
      className={classes}
      ref={ref}
      {...props}
    />
  )
})

FlexChild.defaultProps = {
  grow: 1,
  minWidth: null,
  maxWidth: null,
  className: undefined,
}

export default FlexChild
